import { Component, OnInit } from '@angular/core';
import { CPartnerOrganization } from '../../../models/company.models/partnerOrganization.model';
import { PartnerOrganizationService } from '../../../services/partnerOrganization.service';
import { API_ServerAddress } from '../../../MyAppCommonConfig';
import { CCommonPage } from '../../../models/page.models/commonPage.model';
import { CommonPageService } from '../../../services/commonPage.service';
import { Title, Meta } from '@angular/platform-browser';


@Component({
    selector: 'insurances',
    templateUrl: 'insurances.component.html'
})
export class InsurancesComponent implements OnInit {
    ngOnInit(): void {
        this.GetCommonPage();
        this.GetPartnerOrganizationArray();
    }

    partnerOrganizationArray: CPartnerOrganization[] = [];
    ApiServiceAddress: string;
    commonPage: CCommonPage = new CCommonPage();
    id: string = 'PartnerOrganizationsIndex';

    constructor(private partnerOrganizationService: PartnerOrganizationService,
        private commonPageService: CommonPageService, private titleService: Title, private metaService: Meta) {
        this.ApiServiceAddress = API_ServerAddress;
    }


    GetPartnerOrganizationArray() {
        this.partnerOrganizationService.GetList().subscribe((data: CPartnerOrganization[]) => this.partnerOrganizationArray = data);
    }

    GetCommonPage() {
        this.commonPageService.GetById(this.id)
            .subscribe((data: CCommonPage) => {
                this.commonPage = data;
                this.SetPageMetaData(data);
            });
    }

    SetPageMetaData(model: CCommonPage) {
        this.titleService.setTitle(model.fMetaTitle);
        this.metaService.updateTag({ name: 'description', content: model.fMetaDescription });
        this.metaService.updateTag({ name: 'keywords', content: model.fMetaKeywords });
    }
}